import React from 'react';


const Service = () => {
    return (
        <div id="service">
            <h1 className="text-center py-5">My Service</h1>
            <div className="row row-cols-1 row-cols-md-2 g-4 container mx-auto">
  <div className="col">
    <div className="card">
      <img src="https://wallpapercave.com/wp/wp6784380.jpg" className="card-img-top" alt="..."/>
      <div className="card-body">
        <h5 className="card-title">Web Development</h5>
        <p className="card-text">We are given you best service for the development your web base application .so why you are waiting for?  </p>
      </div>
    </div>
  </div>
  <div className="col">
    <div className="card">
      <img src="https://content.techgig.com/thumb/msid-82294144,width-860,resizemode-4/5-Things-to-know-to-become-a-Web-Developer-in-2021.jpg?49831" className="card-img-top" alt="..."/>
      <div className="card-body">
        <h5 className="card-title">Web Designer</h5>
        <p className="card-text">I have special and advanced skills at design  . I can make website psd to html ,figma to convert right way .I always thinking about the best service
 </p>
      </div>
    </div>
  </div>
  <div className="col">
    <div className="card">
      <img src="https://www.oberlo.com/media/1603954182-seo-article-header.png" className="card-img-top" alt="..."/>
      <div className="card-body">
        <h5 className="card-title">SEO Marketing</h5>
        <p className="card-text">web site needed seo don't forget to knowing me .</p>
      </div>
    </div>
  </div>
  <div className="col">
    <div className="card">
      <img src="https://www.dynodesoft.com/assets/img/ecom1.5.gif" className="card-img-top" alt="..."/>
      <div className="card-body">
        <h5 className="card-title">Web Banner</h5>
        <p className="card-text">i will make banner for the web branding .</p>
      </div>
    </div>
  </div>
</div>
        </div>
    );
};

export default Service;